export const TypographyVariants = {
  // Displat Styles
  display_1_medium: "display_1_medium",
  display_1_bold: "display_1_bold",
  display_2_medium: "display_2_medium",
  display_2_bold: "display_2_bold",

  // Title Styles
  title_1_medium: "title_1_medium",
  title_1_bold: "title_1_bold",
  title_1_extra_bold: "title_1_extra_bold",
  title_2_medium: "title_2_medium",
  title_2_bold: "title_2_bold",
  title_2_extra_bold: "title_2_extra_bold",

  // Heading Styles
  h_1_medium: "h_1_medium",
  h_1_bold: "h_1_bold",
  h_1_extra_bold: "h_1_extra_bold",
  h_2_medium: "h_2_medium",
  h_2_bold: "h_2_bold",
  h_2_extra_bold: "h_2_extra_bold",
  h_3_medium: "h_3_medium",
  h_3_bold: "h_3_bold",
  h_3_extra_bold: "h_3_extra_bold",
  h_4_medium: "h_4_medium",
  h_4_bold: "h_4_bold",
  h_4_extra_bold: "h_4_extra_bold",

  // Body Styles
  body_1_regular: "body_1_regular",
  body_1_medium: "body_1_medium",
  body_2_regular: "body_2_regular",
  body_2_medium: "body_2_medium",
  body_3_regular: "body_3_regular",
  body_3_medium: "body_3_medium",
  body_4_regular: "body_4_regular",
  body_4_medium: "body_4_medium",

  // Label Styles
  label_1_regular: "label_1_regular",
  label_1_medium: "label_1_medium",
  label_1_semi_bold: "label_1_semi_bold",
  label_1_bold: "label_1_bold",
  label_2_regular: "label_2_regular",
  label_2_medium: "label_2_medium",
  label_2_semi_bold: "label_2_semi_bold",
  label_2_bold: "label_2_bold",
  label_3_regular: "label_3_regular",
  label_3_medium: "label_3_medium",
  label_3_semi_bold: "label_3_semi_bold",
  label_3_bold: "label_3_bold",
  label_4_regular: "label_4_regular",
  label_4_medium: "label_4_medium",
  label_4_semi_bold: "label_4_semi_bold",
  label_4_bold: "label_4_bold",

  // Tiny and Tiny Extended Styles
  tiny_medium: "tiny_medium",
  tiny_semi_bold: "tiny_semi_bold",
  tiny_bold: "tiny_bold",
  tiny_extended_medium: "tiny_extended_medium",
  tiny_extended_semi_bold: "tiny_extended_semi_bold",
  tiny_extended_bold: "tiny_extended_bold",
};

export const TypographyTags = {
  p: "p",
  div: "div",
  span: "span",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
};

export type TypographyVariantsTypes = keyof typeof TypographyVariants;
export type TypographyTagsTypes = keyof typeof TypographyTags;
